import { render } from "./right.vue?vue&type=template&id=690156d0&scoped=true"
import script from "./right.vue?vue&type=script&lang=js"
export * from "./right.vue?vue&type=script&lang=js"

import "./right.vue?vue&type=style&index=0&id=690156d0&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690156d0"]])

export default __exports__